/*
 * Additional frontend module dedicated to Estate management asset map.
 *
 * It is configured (in webpack conf) as a standalone module since it does not need to
 * be included in main module, just load this module when you need it.
 *
 * On frontend side itself it only requires googlemaps libraries. Purpose of this
 * module is only to build the Map UI from given data. Backend is still the master of
 * truth where come every data, except the API version.
 *
 * The code relies on:
 *
 * - An unique element HTML with id 'estate_asset_map';
 * - A JSON payload for map settings avalaible in HTML from a 'script' element with id
 *   'estate-assets-map-settings';
 * - A JSON payload for assets avalaible in HTML from a 'script' element with id
 *   'estate-assets-items';
 * - Some CSS rules for the map layout, especially its height that must be explicitely
 *   defined (or you will probably won't see any map despite working);
 *
 * It is recommended to load this module with 'defer' mode to avoid googlemap API to
 * block rendering.
 *
 * Finally, the Map API is versionned and we set it here from constant 'MAP_API_VERSION'
 * since it hardly defines what feature can be used, it won't be relevant to change it
 * from backend settings that could break implementations.
*/

import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer } from "@googlemaps/markerclusterer";


document.addEventListener("DOMContentLoaded", function () {
    const MAP_API_VERSION = "weekly";

    // Parse settings JSON payload from DOM
    let mapSettings = JSON.parse(
        document.getElementById("estate-assets-map-settings").textContent
    );
    // Parse asset JSON payload from DOM
    let assetsPayload = JSON.parse(
        document.getElementById("estate-assets-items").textContent
    );

    // Init googlemap API loader
    const loader = new Loader({
        apiKey: mapSettings.apikey,
        version: MAP_API_VERSION,
    });

    // Start map and markers computation once loader is ready
    loader.load().then(async () => {
        // const { Size } = await google.maps.importLibrary("core");
        const { Map } = await google.maps.importLibrary("maps");
        // v3.56 is required for AdvancedMarkerElement and PinElement
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker");

        // Init map with settings
        let map = new Map(document.getElementById("estate_asset_map"), {
            center: mapSettings.center,
            zoom: mapSettings.zoom,
            mapId: mapSettings.mapId,
        });

        // Init internal map popin where to display marker infos (only a single shared
        // for every marker)
        const infoWindow = new google.maps.InfoWindow({
            content: "",
            disableAutoPan: false,
            shouldFocus: false,
            minWidth: mapSettings.infoWindow.minWidth,
            maxWidth: mapSettings.infoWindow.maxWidth
        });

        // Build marker object map from asset payload
        const assetMarkers = assetsPayload.map((item, i) => {
            // Create an image element to use as pin glyph
            const glyphImg = document.createElement("img");
            glyphImg.src = item.icon;
            // Create pin element with asset icon as pin glyph
            const glyphSvgPinElement = new PinElement({
                glyph: glyphImg,
                background: mapSettings.pinElement.background,
                borderColor: mapSettings.pinElement.borderColor
            });

            // Create the asset marker
            const marker = new AdvancedMarkerElement({
                map,
                position: { lat: item.lat, lng: item.lng },
                title: item.title,
                content: glyphSvgPinElement.element,
            });

            // Bind marker click to fill and open the shared popin
            marker.addListener("click", () => {
                infoWindow.close();
                infoWindow.setContent(item.infoWindow);
                infoWindow.open({ map, anchor: marker });
            });

            return marker;
        });

        // Add a marker clusterer to manage the markers.
        new MarkerClusterer({ map: map, markers: assetMarkers });
    });
});
